export default {"src":"/_next/static/media/macadamias.5b407b77.svg","height":619,"width":619,"blurWidth":0,"blurHeight":0};